module.exports = __webpack_public_path__ + "img/telephone-call-receiver_small.63a7d35d.svg";